const PressJoinCategory = {
	SelfClinchingNuts: 0,
	SelfClinchingThreadedStud: 1,
	SelfClinchingThreadedStandoff: 2,
};

export default PressJoinCategory;
